// Vendors
import React from 'react';
import { Switch, Route } from 'react-router-dom';

// Pages
import getPages from '../pages';
import PAGE_TYPES from '../pages/pageTypes';

const {
  AccountRecoveryPage,
  CreateAccountPage,
  NoMatchPage,
  ForgotPasswordPage,
  ForgotUsernamePage,
  MobileDLIDScan,
  TermsConditionsPage,
} = getPages(PAGE_TYPES.PUBLIC);

export const MOBILE_DL_SCAN_PATH = '/dl-scan';

// TODO: this could be an array of objects that is mapped through to create our routes below
export const publicRoutes = [
  '/',
  '/es',
  '/sign-in',
  '/account-recovery',
  '/dmv/vehicle-registration-renewal',
  '/es/dmv/renovacion-registro-vehiculo',
  '/tdlr/massage-therapy-license-renewals',
  '/es/tdlr/renovacion-licencia-de-terapia-masaje',
  '/create-account',
  '/forgot-password',
  '/dps/driver-license-id-renewal-replacement',
  '/es/dps/renovacion-licencia-de-conducir',
  '/tpwd/boat-services',
  '/es/tpwd/servicios-de-embarcación',
  '/forgot-username',
  '/terms-conditions',
];

const RoutesPublic = () => (
  <Switch>
    <Route path="/account-recovery" component={AccountRecoveryPage} />
    <Route path="/create-account" component={CreateAccountPage} />
    <Route path="/forgot-password" component={ForgotPasswordPage} />
    <Route path="/forgot-username" component={ForgotUsernamePage} />
    <Route path="/terms-conditions" component={TermsConditionsPage} />
    <Route
      exact
      path={`${MOBILE_DL_SCAN_PATH}/:sessionId`}
      component={MobileDLIDScan}
    />
    <Route component={NoMatchPage} />
  </Switch>
);

export default RoutesPublic;
